import { api } from '@/lib/api/client';
import type { RetentionPolicy, ErasureRequest, ErasureRequestStatus, RevealedIdentity } from './types';

// backend/routes/data-privacy.js exports two routers (a live bug, found and
// fixed 2026-09-06, once mounted one at bare /api instead) — the admin ones
// live at /api/admin/data-privacy/*, the per-patient one at /api/patients/*.
export const fetchRetentionPolicy = () => api.get<RetentionPolicy>('/admin/data-privacy/data-retention');

export const saveRetentionPolicy = (data: { retention_years?: number; policy_notes?: string }) =>
  api.patch<RetentionPolicy>('/admin/data-privacy/data-retention', data);

export const fetchErasureRequests = (status?: ErasureRequestStatus) =>
  api.get<ErasureRequest[]>(`/admin/data-privacy/erasure-requests${status ? `?status=${status}` : ''}`);

/** For a patient record screen — that patient's own request history. */
export const fetchPatientErasureRequests = (uhid: string) =>
  api.get<ErasureRequest[]>(`/patients/${uhid}/erasure-requests`);

export const createErasureRequest = (uhid: string, reason?: string) =>
  api.post<ErasureRequest>(`/patients/${uhid}/erasure-requests`, { reason });

export const reviewErasureRequest = (id: number, status: 'approved' | 'rejected', resolution_notes?: string) =>
  api.patch<ErasureRequest>(`/admin/data-privacy/erasure-requests/${id}`, { status, resolution_notes });

/** The actual (irreversible) redaction — only valid on a previously-approved request. */
export const completeErasureRequest = (id: number) =>
  api.post<{ completed: boolean; uhid: string }>(`/admin/data-privacy/erasure-requests/${id}/complete`);

/**
 * The restricted re-identification key — decrypts and returns the
 * pre-erasure identity for a legal/regulatory need that names the patient
 * rather than their UHID. Gated on the separate admin:legal-hold grant, and
 * every call is audited server-side with `reason`, success or not.
 */
export const revealErasedIdentity = (id: number, reason: string) =>
  api.post<RevealedIdentity>(`/admin/data-privacy/erasure-requests/${id}/reveal-identity`, { reason });
